import Vue from 'vue';
import browserDetect from 'vue-browser-detect-plugin';
import Antd from 'ant-design-vue';
import VueEasySession from 'vue-easysession';
import AOS from 'aos';
import BootstrapVue from 'bootstrap-vue';
import Vuex from 'vuex';
import VueAxios from 'vue-axios';
import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import {
  faFacebookSquare,
  faPinterest,
  faLinkedin,
  faTwitter,
  faGooglePlusG,
  faInstagram,
  faLine,
} from '@fortawesome/free-brands-svg-icons';
import Vuetify from 'vuetify';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faVolumeUp,
  faSortDown,
  faPlus,
  faMinus,
  faCommentDots,
  faHome,
  faUser,
  faLock,
  faUserCircle,
  faDollarSign,
  faKey,
  faSignOutAlt,
} from '@fortawesome/free-solid-svg-icons';
import App from './App.vue';
import store from './store';
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import './assets/css/amb-poker-stylesheet.css';
import router from './router';
// import SocketIO from 'socket.io-client'
// import VueSocketIO from 'vue-socket.io'
import 'aos/dist/aos.css';
// import {SOCKET_URL} from "./utils/api"
import 'ant-design-vue/dist/antd.css';
// import RuleHeader from '../src/components/gamesrule/rulesComponents/ruleHeaderConent.vue';
import RuleHeader from './components/gamesrule/rulesComponents/ruleHeaderConent.vue';
import RuleGame from './components/gamesrule/rulesComponents/ruleGameContent.vue';
import vuesocket from './vue-socket';

import utils from './services/utils';
import { ENV, APK_URL, BASE_URL } from './utils/api';

const options = {
  persist: false,
  keySession: 'ambpoker-session',
  expireSessionCallback: () => {
    window.location.href = '/';
  },
};

Vue.use(BootstrapVue);
Vue.use(VueEasySession.install, options);
Vue.use(AOS);
Vue.use(Vuex);
Vue.use(Vuetify);
Vue.use(Antd);
Vue.use(browserDetect);

Vue.component('rule-header', RuleHeader);
Vue.component('rule-game', RuleGame);

Vue.component('modal', {
  template: '#modal-template',
});

// // Vue-socket
// const optionSocket = {autoConnect: true, query: `token=${baseToken}`}
// Vue.use(new VueSocketIO({
//     debug: false,
//     connection: SocketIO(SOCKET_URL, optionSocket), //options object is Optional
//     vuex: {
//       store,
//       actionPrefix: "SOCKET_",
//       mutationPrefix: "SOCKET_"
//     }
//   })
// )

Vue.use(vuesocket('eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJyb2xlIjoiTk9fVE9LRU4ifQ.dFxNio8Imju3RVRwb0g1HJzyIdymmx6fYiWmUt1qqlI'));

Vue.prototype.$baseToken = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJyb2xlIjoiTk9fVE9LRU4ifQ.dFxNio8Imju3RVRwb0g1HJzyIdymmx6fYiWmUt1qqlI';

Vue.prototype.$urlDownload = APK_URL;

library.add(
  faGooglePlusG,
  faPlus,
  faMinus,
  faCommentDots,
  faSortDown,
  faUser,
  faLock,
  faUserCircle,
  faKey,
  faSignOutAlt,
  faDollarSign,
  faFacebookSquare,
  faPinterest,
  faLinkedin,
  faTwitter,
  faInstagram,
  faLine,
  faVolumeUp,
  faHome,
);
Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.use(VueAxios, axios);

Vue.axios.interceptors.request.use((request) => {
  if (ENV.toString() === 'prod') {
    if (request.url.includes(BASE_URL)) {
      utils.encryptSensitiveData(request.data);
    }
  }
  return request;
},
(error) => error);

const userPersistent = utils.getUserPersistent();
if (userPersistent.token) {
  Vue.axios.defaults.headers.common.Authorization = `Bearer ${userPersistent.token}`;
}
Vue.config.productionTip = false;

// eslint-disable-next-line no-new
new Vue({
  created() {
    AOS.init({
      duration: 1200,
    });
  },
  el: '#app',
  router,
  store,
  render: (h) => h(App),
});
